<template>
  <b-nav-item-dropdown
    ref="notificationDrop"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="activeUnreadNotifications.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t("Notifications") }}
        </h4>
      </div>
    </li>

    <!-- Notifications -->
    <div
      ref="notificationsScroll"
      class="notificationsScroll scrollable-container media-list scroll-area"
    >
      <!-- Account Notification -->

      <div
        v-for="(notification, index) in notificationData"
        :key="notification.id || `${notification.guid || 'notification'}-${index}`"
        class="notification-item"
        :class="{ 'notification-unread': notification.active }"
      >
        <b-media
          @click="redirectNotification(notification)"
          style="cursor: pointer"
        >
          <template #aside>
            <div class="p-1 bg-primary rounded">
              <feather-icon class="text-white" icon="BellIcon" size="20" />
            </div>
            <!-- <b-avatar size="32" :src="notification.avatar" :text="notification.avatar" :variant="notification.type" /> -->
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.module }}
            </span>
          </p>
          <p style="font-size: smaller">{{ notification.message }}</p>
        </b-media>
      </div>

      <div
        v-if="notificationsLoaded && !notificationData.length"
        class="notification-empty-state"
      >
        <feather-icon icon="BellOffIcon" size="32" />
        <p class="mb-0">{{ $t("NoUnreadNotifications") }}</p>
      </div>

      <div
        v-if="isLoadingMoreNotifications"
        class="notification-loading-state"
      >
        <span class="notification-loader"></span>
        <span>{{ $t("LoadingNotifications") }}</span>
      </div>

      <div ref="observerNotifications" class="notification-scroll-observer"></div>

      <!-- System Notification Toggler -->

      <!-- System Notifications -->
    </div>

    <!-- Cart Footer -->
    <li v-if="activeUnreadNotifications.length" class="dropdown-menu-footer">
      <b-button
        @click="markReadAll"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        >{{ $t("ReadAllNotifications") }}</b-button
      >
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import {
  showBackOfficeUser,
  allNotifications,
  createSignalRConnection,
  updateNotification,
} from "@/@core/api/request";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },

  data() {
    return {
      reconnectTimer: null,
      connection: null,
      isSignalRDestroyed: false,
      observer: null,
      isConnectionActive: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      hasMoreNotifications: true,
      isLoadingMoreNotifications: false,

      creatorData: null,
      notificationData: [],
      unreadNotifications: [],
      notificationsLoaded: false,
      allMounted: false,
      notificationsPage: 1,
      notificationsTotalPages: 1,
      notificationsTotalRows: 0,

      notFake: [
        {
          module: "one",
          message: "mmm",
        },
        {
          module: "two",
          message: "mmm2",
        },
        {
          module: "three",
          message: "mmm3",
        },
      ],
    };
  },

  computed: {
    activeUnreadNotifications() {
      return this.unreadNotifications.filter(
        (notification) => notification?.active === true,
      );
    },
  },

  directives: {
    Ripple,
  },

  async mounted() {
    try {
      const user = this.$store.state.appConfig;
      const userId =
        user?.idUser ??
        user?.sessionContext?.idUser ??
        user?.user?.idUser ??
        null;

      if (!userId) {
        console.error("ID de usuario no disponible");
        return;
      }

      this.creatorData = userId;

      if (user.role !== "BACKOFFICE") {
        await this.initializeNotifications();
        this.setupSignalR();
      }
    } catch (error) {
      console.error("Error en inicialización:", error);
    }
    // if (["COMPANY"].includes(user.role)) {
    //   const options = {
    //     root: null, // Usa el viewport como root
    //     rootMargin: "0px",
    //     threshold: 0.1, // Ejecuta cuando el 10% del elemento sea visible
    //   };

    //   this.observer = new IntersectionObserver(
    //     this.interceptNotifications,
    //     options
    //   );
    //   const target = this.$refs.observerNotifications;
    //   this.observer.observe(target);
    //   this.creatorData = user.idUser;

    //   await allNotifications(this.creatorData, 1, 999999999, true)
    //     .then((response) => {
    //       this.unreadNotifications = response.data.items;
    //     })
    //     .catch((error) => {});

    //   await allNotifications(this.creatorData, this.notificationsPage, 20)
    //     .then((response) => {
    //       this.notificationData = response.data.items;
    //       this.notificationsLoaded = true;
    //     })
    //     .catch((error) => {});

    //   //In live notifications

    //   this.connection = createSignalRConnection(
    //     `notificationhub?userId=${this.creatorData}`
    //   );

    //   this.connection.onclose((error) => {
    //     if (error) {
    //       console.log("Conexión perdida. Error:", error);
    //       this.reconnectSignalR();
    //     } else {
    //       console.log("Conexión cerrada sin error.");
    //     }
    //   });

    //   this.connection.on("ReceiveNotification", async (notification) => {
    //     this.notificationsPage = 1;
    //     await allNotifications(this.creatorData, this.notificationsPage, 20)
    //       .then((response) => {
    //         this.notificationData = response.data.items;
    //         this.notificationsLoaded = true;
    //       })
    //       .catch((error) => {});

    //     await allNotifications(this.creatorData, 1, 999999999, true)
    //       .then((response) => {
    //         this.unreadNotifications = response.data.items;
    //         this.notificationsLoaded = true;
    //       })
    //       .catch((error) => {});

    //     this.alertToast("info", "Nueva notificación", notification.message);
    //   });

    //   this.connection.on("Connected", (message) => {
    //     console.log(message);
    //   });

    //   this.connection
    //     .start()
    //     .then(() => {
    //       console.log("Conexión WebSocket establecida con éxito");
    //     })
    //     .catch((err) => {
    //       console.error("Error al establecer conexión con el socket", err);
    //       this.reconnectSignalR(); // Intento de reconexión en caso de fallo
    //     });

    //   this.allMounted = true;
    // } else {
    //   this.notificationData = null;
    // }
  },

  beforeDestroy() {
    this.cleanupConnections();
  },

  methods: {
    normalizeNotificationsResponse(response, fallbackPage = 1) {
      const data = response?.data;
      const items = Array.isArray(data?.items) ? data.items : [];
      const currentPage = Number(data?.currentPage);
      const totalPages = Number(data?.totalPages);
      const totalRows = Number(data?.totalRows);

      return {
        items,
        currentPage:
          Number.isFinite(currentPage) && currentPage > 0
            ? currentPage
            : fallbackPage,
        totalPages:
          Number.isFinite(totalPages) && totalPages > 0 ? totalPages : 1,
        totalRows:
          Number.isFinite(totalRows) && totalRows >= 0
            ? totalRows
            : items.length,
        hasMore:
          Boolean(data) &&
          Number.isFinite(currentPage) &&
          Number.isFinite(totalPages) &&
          currentPage < totalPages,
      };
    },

    notificationId(notification) {
      return notification?.idNotificationsRealTimes ?? notification?.id ?? null;
    },

    async initializeNotifications() {
      try {
        if (!this.creatorData) return;
        const [unreadRes, allRes] = await Promise.all([
          allNotifications(this.creatorData, 1, 100, true).catch((error) => ({
            data: null,
          })),
          allNotifications(this.creatorData, this.notificationsPage, 20).catch(
            (error) => ({ data: null }),
          ),
        ]);

        const unreadPage = this.normalizeNotificationsResponse(unreadRes, 1);
        const notificationsPage = this.normalizeNotificationsResponse(
          allRes,
          this.notificationsPage,
        );

        this.unreadNotifications = unreadPage.items;
        this.notificationData = notificationsPage.items;
        this.notificationsPage = notificationsPage.currentPage;
        this.notificationsTotalPages = notificationsPage.totalPages;
        this.notificationsTotalRows = notificationsPage.totalRows;
        this.hasMoreNotifications = notificationsPage.hasMore;
        this.notificationsLoaded = true;
        this.setupInfiniteScroll();
      } catch (error) {
        console.error("Error loading notifications:", error);
        this.unreadNotifications = [];
        this.notificationData = [];
        this.hasMoreNotifications = false;
        this.notificationsLoaded = true;
      }
    },

    setupInfiniteScroll() {
      // Prevent multiple observers if component remounts
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.$nextTick(() => {
        const scrollContainer = this.$refs.notificationsScroll;
        const target = this.$refs.observerNotifications;
        if (
          !(scrollContainer instanceof Element) ||
          !(target instanceof Element)
        ) {
          console.warn("observerNotifications ref not found or not an Element");
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                entry.isIntersecting &&
                this.hasMoreNotifications &&
                !this.isLoadingMoreNotifications
              ) {
                this.loadMoreNotifications();
              }
            });
          },
          {
            root: scrollContainer,
            rootMargin: "0px",
            threshold: 0.1,
          },
        );
        this.observer.observe(target);
      });
      // this.observer.observe(this.$refs.observerNotifications);
    },

    async loadMoreNotifications() {
      if (
        !this.hasMoreNotifications ||
        this.isLoadingMoreNotifications ||
        !this.creatorData
      )
        return;

      const nextPage = this.notificationsPage + 1;
      this.isLoadingMoreNotifications = true;
      try {
        const response = await allNotifications(
          this.creatorData,
          nextPage,
          20,
        );

        const nextNotificationsPage = this.normalizeNotificationsResponse(
          response,
          nextPage,
        );
        const newNotifications = nextNotificationsPage.items;
        if (!newNotifications.length) {
          this.hasMoreNotifications = false;
          return;
        }

        this.notificationsPage = nextNotificationsPage.currentPage;
        this.notificationsTotalPages = nextNotificationsPage.totalPages;
        this.notificationsTotalRows = nextNotificationsPage.totalRows;
        this.hasMoreNotifications = nextNotificationsPage.hasMore;
        this.notificationData = [...this.notificationData, ...newNotifications];
      } catch (error) {
        console.error("Error loading more notifications:", error);
      } finally {
        this.isLoadingMoreNotifications = false;
      }
    },

    setupSignalR() {
      if (!this.creatorData || this.isSignalRDestroyed) {
        console.error("No se puede conectar a SignalR sin user ID");
        return;
      }
      const connection = createSignalRConnection(
        `notificationhub?userId=${this.creatorData}`,
      );
      this.connection = connection;

      connection.on("ReceiveNotification", this.handleNewNotification);
      connection.onclose((error) => {
        if (connection === this.connection && !this.isSignalRDestroyed) {
          this.handleConnectionClose(error, connection);
        }
      });

      connection.onreconnecting(() => {
        if (connection !== this.connection || this.isSignalRDestroyed) return;
        console.log("Reconexión en progreso...");
        this.isConnectionActive = false;
      });

      connection.onreconnected(() => {
        if (connection !== this.connection || this.isSignalRDestroyed) return;
        console.log("Reconexión exitosa");
        this.isConnectionActive = true;
        this.reconnectAttempts = 0;
      });

      this.startConnection(connection);
    },

    async startConnection(connection = this.connection) {
      if (
        !connection ||
        connection !== this.connection ||
        this.isSignalRDestroyed
      )
        return;
      if (
        connection.state === "Connected" ||
        connection.state === "Connecting" ||
        connection.state === "Reconnecting"
      ) {
        return;
      }
      try {
        await connection.start();
        if (connection !== this.connection || this.isSignalRDestroyed) {
          await connection.stop();
          return;
        }
        console.log("SignalR connected");
        this.isConnectionActive = true;
        this.reconnectAttempts = 0;
      } catch (error) {
        console.error("SignalR connection error:", error);
        this.scheduleReconnection(connection);
      }
      // try {
      //   await this.connection
      //     .start()
      //     .then(() => {
      //       console.log("Conexión SignalR iniciada correctamente");
      //     })
      //     .catch((error) => {
      //       console.log("Error al iniciar la conexión SignalR:", error);
      //       this.reconnectSignalR(); // Intento de reconexión en caso de fallo
      //     });
      // } catch (error) {
      //   console.log("Error al conectar a SignalR:", error);
      //   this.reconnectSignalR(); // Intento de reconexión en caso de fallo
      // }
    },

    handleConnectionClose(error, connection = this.connection) {
      if (error) {
        console.log("Connection lost, attempting reconnect...");
        this.scheduleReconnection(connection);
      }
    },

    scheduleReconnection(connection = this.connection) {
      if (
        !connection ||
        connection !== this.connection ||
        this.isSignalRDestroyed
      )
        return;

      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        const baseDelay = 1000;
        const jitter = Math.random() * 1000;
        const delay = Math.min(
          baseDelay * Math.pow(2, this.reconnectAttempts) + jitter,
          30000,
        );

        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        this.reconnectTimer = setTimeout(() => {
          this.reconnectTimer = null;
          if (connection !== this.connection || this.isSignalRDestroyed) return;
          console.log(`Intento de reconexión #${this.reconnectAttempts + 1}`);
          this.startConnection(connection);
        }, delay);

        this.reconnectAttempts++;
      } else {
        console.error("Máximo de intentos de reconexión alcanzado");
        this.cleanupConnections();
      }
    },

    async handleNewNotification(notification) {
      try {
        // Reset pagination for new notifications
        this.notificationsPage = 1;
        this.hasMoreNotifications = true;

        const [allRes, unreadRes] = await Promise.all([
          allNotifications(this.creatorData, this.notificationsPage, 20),
          allNotifications(this.creatorData, 1, 100, true),
        ]);

        const notificationsPage = this.normalizeNotificationsResponse(
          allRes,
          1,
        );
        const unreadPage = this.normalizeNotificationsResponse(unreadRes, 1);

        this.notificationData = notificationsPage.items;
        this.unreadNotifications = unreadPage.items;
        this.notificationsPage = notificationsPage.currentPage;
        this.notificationsTotalPages = notificationsPage.totalPages;
        this.notificationsTotalRows = notificationsPage.totalRows;
        this.hasMoreNotifications = notificationsPage.hasMore;

        this.alertToast("info", "Nueva notificación", notification.message);
      } catch (error) {
        console.error("Error handling new notification:", error);
      }
    },

    interceptNotifications() {
      if (!this.allMounted) return;

      this.notificationsPage += 1;
      allNotifications(this.creatorData, this.notificationsPage, 20)
        .then((response) => {
          if (response.data) {
            //  console.log("intercept resp", response);
            let responseItems = response.data.items;
            this.notificationData.push(...responseItems);
            this.notificationsLoaded = true;

            //  console.log("la notdata", this.notificationData);
          }
        })
        .catch((error) => {});
    },

    async markReadAll() {
      try {
        const updatePromises = this.unreadNotifications.map((notification) => {
          return updateNotification({ ...notification, active: false });
        });

        await Promise.all(updatePromises);

        this.unreadNotifications = [];
        this.notificationData = this.notificationData.map((n) => ({
          ...n,
          active: false,
        }));
      } catch (error) {
        console.error("Error marking all as read:", error);
      }
      // for (let notification of this.unreadNotifications) {
      //   notification.active = false;
      //   await updateNotification(notification);
      // }

      // this.notificationsPage = 1;
      // await allNotifications(this.creatorData, this.notificationsPage, 20)
      //   .then((response) => {
      //     this.notificationData = response.data.items;
      //     this.notificationsLoaded = true;
      //   })
      //   .catch((error) => {});

      // await allNotifications(this.creatorData, 1, 999999999, true)
      //   .then((response) => {
      //     console.log("unreadresponse", response);

      //     if (response.data) {
      //       this.unreadNotifications = response.data.items;
      //       this.notificationsLoaded = true;
      //     } else {
      //       this.unreadNotifications = [];
      //     }
      //   })
      //   .catch((error) => {});
    },

    async redirectNotification(item) {
      try {
        this.$refs.notificationDrop.hide();

        const selectedNotificationId = this.notificationId(item);
        try {
          await updateNotification({ ...item, active: false });

          if (selectedNotificationId !== null) {
            this.unreadNotifications = this.unreadNotifications.filter(
              (notification) =>
                this.notificationId(notification) !== selectedNotificationId,
            );
          }
          this.notificationData = this.notificationData.map((notification) => {
            const isSelected =
              selectedNotificationId !== null
                ? this.notificationId(notification) === selectedNotificationId
                : notification === item;
            return isSelected
              ? { ...notification, active: false }
              : notification;
          });
        } catch (error) {
          console.error("Error marking notification as read:", error);
        }

        const routePath =
          typeof item?.guid === "string" ? item.guid.trim() : "";
        if (!routePath) return;

        const resolvedRoute = this.$router.resolve(routePath).route;
        const routeExists = resolvedRoute.matched.some(
          (routeRecord) => routeRecord.path !== "*",
        );
        if (routeExists && this.$route.fullPath !== resolvedRoute.fullPath) {
          await this.$router.push(resolvedRoute.fullPath);
        }
      } catch (error) {
        console.error("Error handling notification redirect:", error);
      }
      // let notificationComponent = this.$refs.notificationDrop;
      // notificationComponent.hide();

      // item.active = false;
      // this.$router.push(item.guid);
      // await updateNotification(item);

      // await allNotifications(this.creatorData, 1, 999999999, true)
      //   .then((response) => {
      //     console.log("unreadresponse", response);

      //     if (response.data) {
      //       this.unreadNotifications = response.data.items;
      //       this.notificationsLoaded = true;
      //     } else {
      //       this.unreadNotifications = [];
      //     }
      //   })
      //   .catch((error) => {});
    },

    cleanupConnections() {
      this.isSignalRDestroyed = true;
      this.isConnectionActive = false;
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      if (this.connection) {
        const connection = this.connection;
        this.connection = null;
        connection.off("ReceiveNotification", this.handleNewNotification);
        connection.stop().catch((error) => {
          console.log("Error cerrando SignalR de notificaciones:", error);
        });
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "BellIcon",
      });
    },
  },

  setup() {
    /* eslint-disable global-require */
    const notifications = [
      {
        title: "Congratulation Sam 🎉",
        avatar: require("@/assets/images/avatars/6-small.png"),
        subtitle: "Won the monthly best seller badge",
        type: "light-success",
      },
      {
        title: "New message received",
        avatar: require("@/assets/images/avatars/9-small.png"),
        subtitle: "You have 10 unread messages",
        type: "light-info",
      },
      {
        title: "Revised Order 👋",
        avatar: "MD",
        subtitle: "MD Inc. order updated",
        type: "light-danger",
      },
    ];
    /* eslint-disable global-require */

    const systemNotifications = [
      {
        title: "Server down",
        subtitle: "USA Server is down due to hight CPU usage",
        type: "light-danger",
        icon: "XIcon",
      },
      {
        title: "Sales report generated",
        subtitle: "Last month sales report generated",
        type: "light-success",
        icon: "CheckIcon",
      },
      {
        title: "High memory usage",
        subtitle: "BLR Server using high memory",
        type: "light-warning",
        icon: "AlertTriangleIcon",
      },
    ];

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    return {
      notifications,
      systemNotifications,
      perfectScrollbarSettings,
    };
  },
};
</script>

<style lang="scss">
.notificationsScroll {
  min-height: 110px;
  max-height: 420px;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #0172ff #0172ff20;

  .notification-item {
    border-bottom: 1px solid rgba(34, 41, 47, 0.06);
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(1, 114, 255, 0.08);
    }
  }

  .notification-unread {
    background-color: rgba(1, 114, 255, 0.12);
    box-shadow: inset 3px 0 0 #0172ff;
  }

  .notification-empty-state,
  .notification-loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b9b9c3;
  }

  .notification-empty-state {
    min-height: 150px;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    text-align: center;
  }

  .notification-loading-state {
    gap: 8px;
    padding: 12px 16px;
    font-size: 0.875rem;
  }

  .notification-loader {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(1, 114, 255, 0.2);
    border-top-color: #0172ff;
    border-radius: 50%;
    animation: notification-spin 0.8s linear infinite;
  }

  .notification-scroll-observer {
    width: 100%;
    height: 2px;
  }

  &::-webkit-scrollbar {
    width: 6px;

    border-radius: 10px;
    margin-right: 5px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #0172ff20;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0172ff;
    border-radius: 10px;
  }
}

@media (max-height: 600px) {
  .notificationsScroll {
    max-height: calc(100vh - 180px);
  }
}

@keyframes notification-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
